import React from 'react';
import classes from './SupportFaq.module.css';
import { FaqType } from '../../../screens/Support/Support';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  faq: FaqType[];
};

const SupportFaq: React.FC<Props> = ({ faq }) => {
  const { translations } = useTranslation();

  return (
    <div className={classes.container}>
      {/* {faq.map((qa, index) => (
        <Accordion
          key={index}
          header={`${qa.position}. ${qa.title}`}
          containerStyle={{ boxShadow: 'none' }}
          bodyStyle={{ marginBottom: 10 }}
        >
          <div style={{ marginTop: -10 }}>{removeHtmlTags(qa.description)}</div>
        </Accordion>
      ))} */}
      {translations('qa.first_text')}
      <a href="support@ecocare.de">support@ecocare.de</a> {translations('qa.second_text')}
    </div>
  );
};

export { SupportFaq };
